import styled from 'styled-components';
import { Button, Image, Link } from '@minerva-analytics/pantheon';
import { WHITE, FACEBOOK_BLUE, GOOGLE_BLUE } from 'root/theme';
import { FaFacebook } from 'react-icons/fa';

const LoginButton = styled(Button)`
  border: 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 100%;
  min-width: 200px;
  max-width: 350px;
  padding: 5px;
  ${(props) => props.small ? `
    height: 2.8rem;
    margin: 10px auto;` : ``}
`;

const FacebookLoginButton = styled(LoginButton).attrs({
  background: FACEBOOK_BLUE,
  color: WHITE,
})`
`;

const GoogleLoginButton = styled(LoginButton).attrs({
  background: GOOGLE_BLUE,
  color: WHITE,
})`
`;

const ButtonText = styled.div`
  padding: 0 0 0 40px;
  text-align: left;
  font-weight: 600;
  ${(props) => props.small ? `font-size: 14px;` : ``}
  margin: 0;
`;

const GoogleImageWrapper = styled.div`
  background: ${WHITE};
  border-radius: 3px;
  height: 100%;
  padding: ${(props) => props.small ? `0.2rem` : `calc(1rem - 9px)`};
`;

const GoogleImage = styled(Image)`
  height: ${(props) => props.small ? `1.6rem` : `2rem`};
`;

const FacebookImage = styled(FaFacebook).attrs({
  stroke: WHITE,
  fill: WHITE,
  viewBox: `0 25 448 448`,
  width: `48px`,
})`
  height: ${(props) => props.small === `true` ? `2rem` : `3rem`};
  width: ${(props) => props.small === `true` ? `2rem` : `3rem`};
  flex-shrink: 0;
  border-radius: 3px 0 0 3px;
`;

const ToggleFacebookLink = styled(Link)`
  margin-top: 10px;
  min-width: 200px;
  max-width: 350px;
`;

export {
  FacebookLoginButton,
  GoogleLoginButton,
  ButtonText,
  GoogleImage,
  GoogleImageWrapper,
  FacebookImage,
  ToggleFacebookLink,
};
